import React from 'react';
import ClassifyCamAIHeader from '../Header/ClassifyCamAIHeader/ClassifyCamAIHeader';
// import './ClassifyCamAI.css';

const ClassifyCamAI = () => (
  <section className="product-display-container" id="classifycam">
    <ClassifyCamAIHeader />
    <div className="product-detail-grid">
      <div className="detail-narrative">
        <h3>Edge Acoustic Event Classification</h3>
        <p className="p__opensans">
          ClassifyCamAI implements high-frequency digital signal processing pipelines on local hardware matrices.
          It continuously isolates background environments, classifying physical acoustic patterns (such as alarms, operational anomalies,
          and machinery failures) without streaming raw data streams back to central compute targets.
        </p>
        <a href="https://apps.apple.com/in/app/classifycam/id6737196261" target="_blank" rel="noreferrer" className="appstore-action-link">
          Deploy via iOS App Store ↗
        </a>
      </div>
      <div className="detail-specs-box">
        <h4>Telemetry Specifications</h4>
        <ul>
          <li>Processing: Async Spectrogram FFT Transformation</li>
          <li>Security Topology: Isolated Local Sandbox Model</li>
          <li>Primary GTM Use Cases: Ambient Monitoring, Operations Safety Auditing</li>
        </ul>
      </div>
    </div>
  </section>
);

export default ClassifyCamAI;
